import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()
    const apiDomain = config.public.apiDomain

    window.Pusher = Pusher

    const echo = new Echo({
        broadcaster: 'reverb',
        key: config.public.reverbKey,
        wsHost: config.public.reverbHost,
        wsPort: parseInt(config.public.reverbPort),
        wssPort: parseInt(config.public.reverbPort),
        forceTLS: config.public.reverbScheme === 'https',
        enabledTransports: ['ws', 'wss'],
        // Custom authorizer — reads auth tokens dynamically
        authorizer: (channel) => ({
            authorize: (socketId, callback) => {
                const body = new URLSearchParams({
                    socket_id:    socketId,
                    channel_name: channel.name,
                })
                fetch(apiDomain + '/chat/broadcast-auth', {
                    method:  'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Id':    localStorage.getItem('Id')    || '',
                        'Token': localStorage.getItem('Token') || '',
                    },
                    body,
                })
                .then(r => r.json())
                .then(data => callback(null, data))
                .catch(err  => callback(err, null))
            },
        }),
    })

    return {
        provide: { echo },
    }
})
